export default "__VITE_ASSET__d298bc13__"